import React, { type RefObject, useCallback } from 'react';

import type { DialogContentProps } from '@atlaskit/popup/types';

import { FocusOnLoad, type FocusOnLoadProps } from './focus-on-load';

type FocusOnContainerOnLoadProps = Omit<FocusOnLoadProps, 'onLoad'> & {
	setInitialFocusRef: RefObject<DialogContentProps['setInitialFocusRef'] | null>;
};

/**
 * Moves focus to the popup container once the entry point has finished loading,
 * matching Popup's default auto-focus behavior.
 */
export function FocusOnContainerOnLoad({
	entryPointReference,
	setInitialFocusRef,
	waitForContentReady,
}: FocusOnContainerOnLoadProps): React.JSX.Element {
	const handleLoad = useCallback(
		(container: HTMLElement) => {
			setInitialFocusRef.current?.(container);
			container.focus();
		},
		[setInitialFocusRef],
	);

	return (
		<FocusOnLoad
			entryPointReference={entryPointReference}
			onLoad={handleLoad}
			waitForContentReady={waitForContentReady}
		/>
	);
}
